import signedFetch from '../util/signedFetch.js';

export default body => signedFetch('redeemVstCode', `${__API_BASE__}/products/redeem-code/vst`, 'POST', body);
